<div class="frame-wrapper" [style.height.px]="companyInfoDetailHeight">
  <!-- header -->
  <div class="frame-wrapper__topper">
    <img (click)="goBackToMain()" [src]="weblinkIcons.back" width="20" height="20" alt="back" class="frame-wrapper__clickable">
  </div>
  <!-- image -->
  <div class="frame-wrapper__icon">
    <span>
      <img (click)="goBackToMain()" [src]="mediaData?.co_icon" alt="logo" class="frame-wrapper__clickable">
    </span>
  </div>
  <!-- container -->
    <div class="frame-wrapper__container w-100 h-100">
      <div [ngClass]="{'frame-wrapper__font-group-height pb-2': !mediaData?.co_is_ctos_verified}">
        <p class="frame-wrapper__font-white mb-0"> {{ mediaData?.co_name }} </p>
        <a href="javascript:;" *ngIf="mediaData?.co_is_ctos_verified" (click)="openCtosPdf()">
          <p class="frame-wrapper__font-green mb-0">({{ mediaData?.co_regno }})</p>
        </a>
        <p class="frame-wrapper__font-green frame-wrapper__clickable mb-0" *ngIf="!mediaData?.co_is_ctos_verified" (click)="triggerCardDetail('ctos')">({{ mediaData?.co_regno }})</p>
      </div>
      <div class="frame-wrapper__font-group-height pt-2 pb-3" *ngIf="mediaData?.co_is_ctos_verified">
        <p class="frame-wrapper__font-gray mb-" style="font-size: 10px;"> Verified by </p>
        <a href="https://zerobrandcard.com/ctos-verified-company" target="_blank">
          <img (click)="goBackToMain()" [src]="weblinkIcons?.ctos_badge" style="width: 3.6em;" alt="logo" class="frame-wrapper__clickable">
        </a>
      </div>
      <div class="frame-wrapper__container-info" *ngIf="mediaData?.co_address">
        <p class="frame-wrapper__font-gray frame-wrapper__font-gray-bold mb-0">Company Address</p>
        <p class="frame-wrapper__font-white frame-wrapper__clickable mb-0" (click)="triggerCardDetail('address')"> {{mediaData?.co_address}}  </p>
      </div>
      <div class="frame-wrapper__container-info" *ngIf="mediaData?.co_phone">
        <p class="frame-wrapper__font-gray frame-wrapper__font-gray-bold mb-0">Company Number</p>
        <a class="frame-wrapper__font-white" href="tel:{{mediaData?.co_phone}}">{{mediaData?.co_phone}}</a>
      </div>
      <div class="frame-wrapper__container-info" *ngIf="mediaData?.co_fax">
        <p class="frame-wrapper__font-gray frame-wrapper__font-gray-bold mb-0">Company Fax</p>
        <a class="frame-wrapper__font-white" href="tel:{{mediaData?.co_fax}}">{{mediaData?.co_fax}}</a>
      </div>
      <div class="frame-wrapper__container-info" *ngIf="mediaData?.co_email">
        <p class="frame-wrapper__font-gray frame-wrapper__font-gray-bold mb-0">Email</p>
        <a class="frame-wrapper__font-white" href="mailto:{{mediaData?.co_email}}">{{mediaData?.co_email}}</a>
      </div>
      <div class="frame-wrapper__container-info" *ngIf="mediaData?.co_about">
        <p class="frame-wrapper__font-gray frame-wrapper__font-gray-bold mb-0">About Us</p>
        <p class="frame-wrapper__font-white"> {{mediaData?.co_about}}  </p>
      </div>
      <div class="frame-wrapper__container-info" *ngIf="mediaData?.social_links.www">
        <p class="frame-wrapper__font-gray frame-wrapper__font-gray-bold mb-0">Website</p>
        <p class="frame-wrapper__font-white frame-wrapper__clickable" (click)="triggerCardDetail('website')"> {{mediaData?.social_links.www}}  </p>
      </div>
      <div class="frame-wrapper__container-info" *ngIf="mediaData?.co_yearincorp">
        <p class="frame-wrapper__font-gray frame-wrapper__font-gray-bold mb-0">Incorporated Year</p>
        <p class="frame-wrapper__font-white"> {{mediaData?.co_yearincorp}}</p>
      </div>
    </div>

</div>